import { useGetRecap } from '@/api/generated/recaps.ts';
import { PlaceCrumbs } from '@/clients/components/ClientCrumbs.tsx';

import useRecapTitle from '../useRecapTitle.ts';
import useShownRecap from '../useShownRecap.ts';

// Named by what the page shows: the version's title, or the draft's at /draft and /edit.
const RecapCrumb = ({ publicId }: { publicId: string }) => {
    const { recap, version, shownNumber } = useShownRecap(publicId);
    const getTitle = useRecapTitle();

    if (recap.error) return <>{publicId}</>;
    if (!recap.data) return null;
    if (shownNumber === null) return <>{getTitle(recap.data)}</>;
    if (!version.data) return null;
    return <>{getTitle({ ...recap.data, title: version.data.title })}</>;
};

export const RecapParentCrumbs = ({ publicId }: { publicId: string }) => {
    const recap = useGetRecap(publicId);

    if (!recap.data) return null;
    return <PlaceCrumbs item={recap.data} navKey="recaps" />;
};

export default RecapCrumb;
